import * as React from 'react';
import { Component } from 'react';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { MergeUserProps } from './types';
import { LoadOptions } from 'app/types-shared';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { fieldName } from './constants';
import { MergeUserSinglePicker } from 'app/area/administration/shared/merge-user/merge-user-single-picker';
import styles from './merge-user-modal.scss';

export class MergeUserModal extends Component<MergeUserProps> {

  public componentDidMount() {
    this.resetAllValidations();
  }

  private resetAllValidations = () => {
    this.props.resetValidation(fieldName);
  };

  public render() {

    const { className, mergeUser, options, validation, translation,
      onClose, loadOptions, updateMergeUser, deleteMergeUserItem } = this.props;

    const uncheckSelectItem = !this.props.mergeUser?.reassignReferencesToUser?.description;

    const handleOnLoadOptions = (loadOptionsParams: LoadOptions) => {
      loadOptions({
        ...(!!loadOptionsParams.query && {
          query: {
            text: loadOptionsParams.query
          }
        }),
        excludeInactiveUsers: { enabled: !loadOptionsParams.includeDisabled },
        excludeTechnicalUsers: { enabled: true },
        userCode: {
          text: this.props.mergeUser?.id?.toString(),
          negated: true
        }
      });
    };

    const handleOnChange = (reassignReferencesToUser: CodeComplexValue<number>) => {
      this.resetAllValidations();
      updateMergeUser({ ...mergeUser, reassignReferencesToUser });
    };

    const handleClose = () => {
      onClose();
      this.resetAllValidations();
      updateMergeUser(undefined);
    };

    const onDone = () => {
      deleteMergeUserItem(uncheckSelectItem);
    };

    return (<div className={className}>
      <ModalWrapper
        headerTitle={translation.delete_user_title}
        btnTitle={translation.delete_item}
        btnCancelTitle={translation.cancel}
        onClose={handleClose}
        onDone={onDone}
        closeOnDone={false}
        isCancelDisabled={mergeUser?.fetching}
        isDisabled={mergeUser?.fetching}
        invertButtonOrder={true}>
        <div className="row">
          <div className="col-12">
            <p className={styles.multilineText}>
              {replaceTemplateString(translation.merge_user_description,
                mergeUser.id,
                `${mergeUser.personId}, ${mergeUser.name}`
              )}
            </p>
            <p className="mt-4">
              {translation.merge_user_sub_description}
            </p>
          </div>

          <MergeUserSinglePicker
            id={fieldName}
            label={undefined}
            size={12}
            valueItem={mergeUser?.[fieldName]}
            options={options}
            includeDisabledLabel={translation.include_disabled}
            uncheckSelectItem={uncheckSelectItem}
            readOnly={mergeUser?.fetching}
            translation={translation}
            validation={validation?.[fieldName]}
            onLoadOptions={handleOnLoadOptions}
            onChange={handleOnChange} />
        </div>
      </ModalWrapper>
    </div>);
  }
}
